import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { colors } from "../../styles";
import { useAuthStore } from "../../store";
import { forceLogout } from "../../utils";
import MyIcon from "../Icon/MyIcon";
import useMe from "../../hooks/useMe";
import Alert, { useAlert } from "../Alert/Alert";

const ICON_SIZE = 36;
const ACTIVE_ICON_SIZE = 48;

interface ILeftBarProps {
    username: string | undefined;
}

export default function LeftBar({ username }: ILeftBarProps) {

    const { isGuest } = useAuthStore();

    const { meData } = useMe();

    const myType = meData?.user.type;
    const { showAlert, alertProps } = useAlert();

    const { pathname } = useLocation();

    const isSearchActive = pathname.includes("/search");
    const isChatActive = pathname.includes("/chat");

    return (
        <Stack
            backgroundColor={"inherit"}

            direction={{
                base: "column",
                sm: "column",
                md: "column",
                lg: "column",
                xl: "column"
            }}

            justifyContent={"space-between"}
            alignItems={"center"}
            width={"80px"}
            height={"100vh"}
            paddingY={5}
            paddingX={3}
            borderRightWidth={0.5}
            gap={5}
        >

        <VStack justifyContent={"center"} alignItems={"center"}>
            <Link to={"/"}>
                <Image src={"/logo_2x.png"} alt="logo" width={12} height={12} objectFit={"contain"} />
            </Link>
        </VStack>

        {/* 메뉴 */}

        <VStack
            justifyContent={"center"} 
            alignItems={"center"}
            gap={10}
        >
            <Link to={"/search"}>
                <Box
                    width={`${ACTIVE_ICON_SIZE}px`}
                    height={`${ACTIVE_ICON_SIZE}px`}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <Box
                        transition={"transform 0.5s ease"}
                        transform={isSearchActive ? `scale(${ACTIVE_ICON_SIZE / ICON_SIZE})` : "scale(1)"}
                    >
                        <MyIcon src={"/svg/capsule-filled.svg"} alt="search" width={ICON_SIZE} height={ICON_SIZE} />
                    </Box>
                </Box>
            </Link>

            {isGuest || myType === "MEMBER" ? (
                    <Box
                        width={`${ACTIVE_ICON_SIZE}px`}
                        height={`${ACTIVE_ICON_SIZE}px`}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        cursor={"pointer"}
                        onClick={() => {
                            showAlert(
                                myType === "MEMBER"
                                    ? "승인 후 이용할 수 있습니다"
                                    : "회원가입 후 이용할 수 있습니다."
                            );
                        }}
                    >
                        <Box
                            transition={"transform 0.5s ease"}
                            transform={isChatActive ? `scale(${ACTIVE_ICON_SIZE / ICON_SIZE})` : "scale(1)"}
                        >
                            <MyIcon src={"/svg/message-circle.svg"} alt="chat" width={ICON_SIZE} height={ICON_SIZE} />
                        </Box>
                    </Box>
                ) : (
                    <Link to={"/chat"}>
                        <Box
                            width={`${ACTIVE_ICON_SIZE}px`}
                            height={`${ACTIVE_ICON_SIZE}px`}
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                        >
                            <Box
                                transition={"transform 0.5s ease"}
                                transform={isChatActive ? `scale(${ACTIVE_ICON_SIZE / ICON_SIZE})` : "scale(1)"}
                            >
                                <MyIcon src={"/svg/message-circle.svg"} alt="chat" width={ICON_SIZE} height={ICON_SIZE} />
                            </Box>
                        </Box>
                    </Link>
            )}
            
        </VStack>

        {/* 마이페이지 버튼 */}

        <VStack>
                {!isGuest && username && (
                    <Link to={"/me"}>
                        <MyIcon src={"/svg/callbook-line-g1.svg"} alt="user" width={36} height={36} />
                    </Link>
                )}

                {isGuest && (
                    <Button
                        variant={"ghost"}
                        color={colors.g3}
                        _hover={{ backgroundColor: colors.g3, color: colors.white }}
                        onClick={forceLogout}
                    >
                        <Text fontSize={14} fontWeight={400}>나가기</Text>
                    </Button>
                )}

        </VStack>

        <Alert {...alertProps} />

        </Stack>
    )
}